module.exports = __webpack_public_path__ + "img/arrow-right.d5e002b0.svg";